import BentoCaseStudy from "../../components/BentoCaseStudy";
import salesTool from "../../constrains/cases/salesTool";

export default function SalesTool() {
  return <BentoCaseStudy caseStudy={salesTool} />;
}
